<template>
    <div class="product-add">
        <!--form表单-->
        <el-form size="small" ref="form" :model="form" label-width="150px">
            <!--添加门店-->
            <div class="common-form">{{ $t('网址设置') }}</div>
            <el-form-item :label="$t('商城名称')" :rules="[{ required: true, message: $t('商城名称不能为空') }]" prop="name">
                <el-input v-model="form.name" :placeholder="$t('商城名称')" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item :label="$t('网址后缀设置')" >
                <el-input v-model="form.aliasName" :placeholder="$t('网址后缀设置')" class="max-w460"></el-input>
              <div class="form-item-hint">{{ $t('选填，设置后缀可替换下列网址末尾的数字id，方便记忆') }}</div>
            </el-form-item>
            <el-form-item :label="$t('访问网址')" v-if="merchant_id">
                <ul>
                    <li><span style="display: inline-block;width: 100px">{{ $t('手机网站') }}：</span>
                        <a :href="website_url2" target="_blank"> {{ website_url2 }}</a> <span v-if="website_url2">[{{$t('默认') }}]</span>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <a :href="website_url1" target="_blank"> {{ website_url1 }}</a> <span v-if="website_url1">[{{$t('自定义') }}]</span>
                    </li>
                    <li><span style="display: inline-block;width: 100px">{{ $t('Pad点餐网站') }}：</span>
                        <a :href="website_url3" target="_blank"> {{ website_url3 }}</a> <span v-if="website_url3">[{{$t('默认') }}]</span>
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      <a :href="website_url8" target="_blank"> {{ website_url8 }}</a> <span v-if="website_url8">[{{$t('自定义') }}]</span>
                    </li>
                    <li><span style="display: inline-block;width: 100px">{{ $t('收银台网站') }}：</span>
                        <a :href="website_url5" target="_blank"> {{ website_url5 }}</a> <span v-if="website_url5">[{{$t('默认') }}]</span>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <a :href="website_url4" target="_blank"> {{ website_url4 }}</a> <span v-if="website_url4">[{{$t('自定义') }}]</span>
                    </li>
                    <li><span style="display: inline-block;width: 100px">{{ $t('后厨网站') }}：</span>
                        <a :href="website_url7" target="_blank"> {{ website_url7 }}</a> <span v-if="website_url7">[{{$t('默认') }}]</span>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <a :href="website_url6" target="_blank"> {{ website_url6 }}</a> <span v-if="website_url6">[{{$t('自定义') }}]</span>
                    </li>
                </ul>
            </el-form-item>
            <div class="common-form">{{ $t('AI助理形象选择') }}</div>
            <div class="ai-assistant-container">
                <div class="ai-robot" v-for="(item, key) in aiList" @click="selectAi(key, item)"
                    :class="{ 'selected': selectedRobot === key }">
                    <input type="radio" :value="key" v-model="selectedRobot" class="select-radio" />
                    <img :src="host + item + '待机.gif?'+new Date().getTime()">
                </div>
            </div>
            <div class="common-form">{{ $t('手机网站二维码') }}</div>
            <img :src="qrCodeUrl" class="qr" />
            <el-button @click="downloadQr" :disabled="!qrCodeUrl">{{ $t('下载') }}</el-button>
        </el-form>
        <!--上传图片-->
        <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
        </Upload>
    </div>
</template>

<script>
import qs from 'qs';
import SettingApi from '@/api/setting.js';
import { submitResEnum } from "../../../logic/buildStore";
import { formatModel } from '@/utils/base.js';

import Upload from '@/components/file/Upload';
export default {
    name: "officialWebsite",
    components: {
        Upload
    },
    computed: {
        website_url1() {
            if (this.form.aliasName) {
                return window.location.origin + `/${this.form.aliasName}`;
            } else {
                return '';
            }
        },
        website_url2() {
            if (this.merchant_id) {
                return window.location.origin + `/${this.merchant_id}`;
            } else {
                return '';
            }
        },
        website_url3() {
            if (this.merchant_id) {
                return window.location.origin + `/ipad/${this.merchant_id}`;
            } else {
                return '';
            }
        },
        website_url8() {
            if (this.form.aliasName) {
                return window.location.origin + `/ipad/${this.form.aliasName}`;
            } else {
                return '';
            }
        },
        website_url4() {
            if (this.form.aliasName) {
                return window.location.origin + `/cashier/${this.form.aliasName}`;
            } else {
                return '';
            }
        },
        website_url5() {
            if (this.merchant_id) {
                return window.location.origin + `/cashier/${this.merchant_id}`;
            } else {
                return '';
            }
        },

        website_url6() {
            if (this.form.aliasName) {
                return window.location.origin + `/kitchen/${this.form.aliasName}`;
            } else {
                return '';
            }
        },
        website_url7() {
            if (this.merchant_id) {
                return window.location.origin + `/kitchen/${this.merchant_id}`;
            } else {
                return '';
            }
        },
    },
    data() {
        return {
            source: 'mp',
            appid: 0,
            merchant_id: 0,
            /*是否正在加载*/
            loading: false,
            /*form表单数据*/
            form: {
                name: '',
                aliasName: '',
                customer: '',
                key: '',
                sms_open: '',
                wx_open: '',
                is_get_log: 0,
                checkedPay: [],
                avatarUrl: '',
                aiRobotUrl: {
                    'index': 'first',
                    'path': '/image/assistant/first/'
                },
            },
            qrCodeUrl: '',
            selectedCountry: '',
            all_type: [],
            type: [],
            pay_type: [],
            /*是否打开图片选择*/
            isupload: false,
            aiList: [],
            host: "",
            selectedRobot: 'first',
        }
    },
    methods: {
        selectAi(key, item) {
            this.selectedRobot = key
            console.log('selectedRobot', this.selectedRobot)
            console.log('item', item)
            this.form.aiRobotUrl = {
                'index': key,
                'path': item
            }
        },
        validateAliasName(rule, value, callback) {
            const self = this
            const regex = /^[a-zA-Z0-9]+$/; // 匹配只包含数字和英文字母的正则表达式
            if (!regex.test(value)) {
                callback(new Error(self.$t('英文名称必须只包含数字和英文字母')));
            } else {
                callback();
            }
        },
        /*获取配置数据*/
        getParams() {
            let self = this;
            SettingApi.storeDetail({}, true).then(res => {
                let vars = res.data.vars.values;
                self.qrCodeUrl = res.data.qrcodeImgUrl
                self.form = formatModel(self.form, vars);
                self.form.customer = vars.kuaidi100.customer;
                self.form.key = vars.kuaidi100.key;
                self.form.checkedPay = vars.checkedPay;
                self.form.aiRobotUrl = vars.aiRobotUrl;
                if(vars.aiRobotUrl != undefined && vars.aiRobotUrl !=""){
                  self.selectedRobot = vars.aiRobotUrl.index
                }else{
                  self.form.aiRobotUrl ={
                    'index': 'first',
                    'path': '/image/assistant/first/'
                  }
                  self.selectedRobot ='first'
                }
                self.appid = res.data.app_id
                if (vars.aliasName != undefined && vars.aliasName != '') {
                    self.form.aliasName = vars.aliasName
                }
                let appinfo = res.data.app
                if (appinfo.merchant_id) {
                    self.merchant_id = appinfo.merchant_id
                }
                for (let i = 0; i < self.form.checkedPay.length; i++) {
                    self.$set(self.form.checkedPay, i, parseInt(self.form.checkedPay[i]));
                }
                self.pay_type = res.data.pay_type;
                self.loading = false;
            })
                .catch(error => {

                });
        },
        getQrPicUrl() {
            let baseUrl = window.location.protocol + '//' + window.location.host;
            let params = {
                shop_supplier_id: this.$store.state.common.currentStore,
                source: this.source
            };
            return baseUrl + '/index.php/shop/supplier.supplier/qrcode?' + qs.stringify(params);
        },
        downloadQr() {
            // if (!this.$store.state.common.currentStore) {
            //     this.$message({
            //         message: '暂未获取到店铺信息，请稍后尝试',
            //         type: "warning"
            //     })
            // }
            // if (!this.qrCodeUrl) {
            //     return
            // }
            // let urlArr = this.qrCodeUrl.split('/')
            // let fileName = urlArr[urlArr.length - 1]
            // downloadFile(this.qrCodeUrl, fileName)
            if (!this.$store.state.common.currentStore) {
                this.$message({
                    message: '暂未获取到店铺信息，请稍后尝试',
                    type: "warning"
                })
            }
            let baseUrl = window.location.protocol + '//' + window.location.host;
            let params = {
                shop_supplier_id: this.$store.state.common.currentStore,
                source: this.source
            };
            window.location.href = baseUrl + '/index.php/shop/supplier.supplier/qrcode?' + qs.stringify(params);
        },
        /*提交*/
        async onSubmit() {
            return new Promise((resolve) => {
                let self = this;
                let params = this.form;

                console.log('提交',params)
                self.$refs.form.validate(async (valid) => {
                    if (valid) {
                        self.loading = true;
                        let res = await SettingApi.editStore(params, true)
                        if (res && res.code === 1) {
                            resolve(submitResEnum.success)
                        } else {
                            resolve(submitResEnum.submitFailed)
                        }
                        self.loading = false;
                    } else {
                        resolve(submitResEnum.invalidForm)
                    }
                });
            })

        },
        /*选择图片*/
        chooseImg(e) {
            this.type = e;
            this.isupload = true;
        },
        /*关闭选择图片*/
        returnImgsFunc(e) {
            this.isupload = false;
            console.log('chufa', e, this.type)
            if (e != null && e.length > 0) {
                if (this.type == 'logo') {
                    this.form.supplier_logo = e[0].file_path;
                } else if (this.type == 'image') {
                    this.form.supplier_image = e[0].file_path;
                } else if (this.type === 'avatarUrl') {
                    this.form.avatarUrl = e[0].file_path;
                }
            }
        },
        getAiAssistantList() {
            SettingApi.aiAssistantList({}, true).then(res => {
                console.log(res)
                this.aiList = res.data.list;
                this.host = res.data.host;
            }).catch(error => {

            });
        },
    },
    created() {
        // bus.$on('returnImgs', this.returnImgsFunc)
        this.getParams();
        this.getAiAssistantList();

    },
    beforeDestroy() {
        // bus.$off('returnImgs', this.returnImgsFunc)
    }
}
</script>

<style scoped lang="scss">
.product-add {
    .qr {
        width: 200px;
        height: 200px;
    }
}

.ai-assistant-container {
    width: 90%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.ai-robot {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    position: relative;
    cursor: pointer;
}

.ai-robot .caption {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
}

.ai-robot .select-radio {
    position: absolute;
    top: 10px;
    left: 10px;
}

.select-radio {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid #999;
    border-radius: 50%;
    outline: none;
    box-shadow: 0 0 5px #999;
    transition: 0.3s;
}

.select-radio:checked {
    box-shadow: 0 0 5px #0D6EFD;
    background: #0D6EFD;
}

.selected {
    background-color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/basicInfo/officialWebsite.vue